import { render, staticRenderFns } from "./CategoryDropdown.vue?vue&type=template&id=7352af98&scoped=true"
import script from "./CategoryDropdown.vue?vue&type=script&lang=js"
export * from "./CategoryDropdown.vue?vue&type=script&lang=js"
import style0 from "./CategoryDropdown.vue?vue&type=style&index=0&id=7352af98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7352af98",
  null
  
)

export default component.exports